import {
  Box,
  IconButton,
  InputAdornment,
  LinearProgress,
  SxProps,
  TextField,
} from "@mui/material";
import { keyboard } from "@testing-library/user-event/dist/keyboard";
import { FC } from "react";
import { Search, X } from "react-feather";

interface SearchFieldProps {
  onSearchChange?: (value: string) => void;
  onClick?: () => void;
  onClearClick?: () => void;
  onSubmit?: () => void;
  search?: string;
  autoFocus?: boolean;
  error?: boolean;
  disabled?: boolean;
  placeholder?: string;
  loading?: boolean;
  sx?: SxProps;
}

const SearchField: FC<SearchFieldProps> = (props) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        minWidth: 200,
        borderRadius: 6,
        overflow: "hidden",
        ...props.sx,
      }}
    >
      {props.loading && (
        <LinearProgress
          sx={{ position: "absolute", left: 0, right: 0, bottom: 0, zIndex: 2 }}
        />
      )}
      <TextField
        error={props.error}
        disabled={props.disabled}
        onKeyDown={(e) => {
          if (e.key === " ") {
            if (props.onSearchChange)
              // @ts-ignore
              props.onSearchChange(e.target.value + " ");
            e.stopPropagation();
            e.preventDefault();
          }

          if (e.key === "Enter" && props.onSubmit) {
            props.onSubmit();
          }
        }}
        onClick={props.onClick}
        autoFocus={props.autoFocus}
        variant="outlined"
        size="small"
        fullWidth
        placeholder={props.placeholder ?? "Tippe um zu suchen"}
        value={props.search}
        onChange={(e) => {
          if (props.onSearchChange) props.onSearchChange(e.target.value);
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {(props.search?.length ?? 0) <= 0 ? (
                <div style={{ opacity: 0.6 }}></div>
              ) : (
                <IconButton
                  disabled={props.disabled}
                  onClick={(e) => {
                    if (props.onClearClick) {
                      props.onClearClick();
                      e.preventDefault();
                      e.stopPropagation();
                      if (props.onSearchChange) props.onSearchChange("");
                    }
                  }}
                >
                  <X />
                </IconButton>
              )}
            </InputAdornment>
          ),
        }}
        sx={{
          "&, fieldset": {
            borderRadius: 6,
          },
          backgroundColor: "#f3f3f3",
          border: 0,
          outline: "none",
        }}
      />
    </Box>
  );
};

export default SearchField;
